module.exports = __webpack_public_path__ + "static/media/logo_name.7680eec7.png";